import { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import { Locale } from '../../modules/locale'
import { AdditionalTypes } from '../../modules/additionalTypes'
import MainModule from '../../modules/main'
import { Font } from '../../constants'

Locale.getInstance().registerKeySet('fr', 'discoveryPlace', {
  title: 'Où?',
  options: {
    everywhere: "N'importe où",
    aroundMe: 'Autour de moi',
    choose: 'Choisir un lieu',
  },
})

Locale.getInstance().registerKeySet('en', 'discoveryPlace', {
  title: 'Where?',
  options: {
    everywhere: 'Wherever',
    aroundMe: 'Nearby',
    choose: 'Choose a place',
  },
})

export class LvcDiscoveryPlace extends MinzeElement {
  private _selected: string = ''
  private _customLocation: string = ''
  private locations: any[] = []

  reactive: Reactive = [['selected', '', true]]

  async onClick(e: Event): Promise<void> {
    const target = e.target as HTMLElement
    const chip = target.closest('lvc-chip')
    if (chip) {
      const value = chip.getAttribute('value') ?? ''

      if (value === 'choosePlace') {
        MainModule.getInstance().injectIntoDOM('lvc-discovery-place-popup')
        return
      }

      this.selected = value
      this._selected = value

      await this.updateLocations()

      this.rerender()
    }
  }

  async onSet(data: any): Promise<void> {
    if (!data?.id) {
      return
    }

    this._customLocation = data.id
    this._selected = data.id
    this.selected = data.id
    await this.updateLocations()
    this.rerender()
  }

  async onReady(): Promise<void> {
    MainModule.getInstance().getEE().on('lvc:discovery_place:set', this.onSet.bind(this))
    await this.updateLocations()
    this.rerender()
  }

  async updateLocations(): Promise<void> {
    if (this._customLocation) {
      const locations = await MainModule.getInstance().getGeo().getById(this._customLocation)
      this.locations = [locations]
    }
  }

  renderLocations = () => {
    let rendered = []
    for (let k in this.locations) {
      let item = this.locations[k]
      rendered.push(
        `<lvc-chip
          theme="dark-borderless" 
          width="fit-content"
          size="small"
          value="${item.id}" 
          class="location-chip" ${this._selected === item.id ? 'selected=true' : 'selected=false'}
          enable-hover-animation="true"
        >
          ${item.name}
        </lvc-chip>`
      )
    }

    return `
      <lvc-box class="items-container" display="flex" flexDirection="column" alignItems="center" mb="40px">
        <lvc-charlie-ecoute-icon width="235" height="235"></lvc-charlie-ecoute-icon>
        <lvc-box display="flex" flexWrap="wrap" justifyContent="center" columnGap="8px" rowGap="8px">
          <lvc-chip enable-hover-animation="true" theme="dark-borderless" width="fit-content" size="small" value="" class="location-chip" ${this._selected === '' ? 'selected=true' : 'selected=false'}>${Locale.getKey('discoveryPlace.options.everywhere')}</lvc-chip>
          <lvc-chip enable-hover-animation="true" theme="dark-borderless" width="fit-content" size="small" value="aroundMe" class="location-chip" ${this._selected === 'aroundMe' ? 'selected=true' : 'selected=false'}>${Locale.getKey('discoveryPlace.options.aroundMe')}</lvc-chip>
          <lvc-chip enable-hover-animation="true" value="choosePlace" theme="dark-borderless" width="fit-content" size="small" class="location-chip" "selected=false">${Locale.getKey('discoveryPlace.options.choose')}</lvc-chip>
          ${rendered.join('')}
        </lvc-box>
      </lvc-box>
    `
  }

  html = () => /* html */ `
    <h1 class="title">${Locale.getKey('discoveryPlace.title')}</h1>
    ${this.renderLocations()}
  `

  css = () => `
    :host {
      max-width: 540px;
      width: 100%;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      font-size: 60px;
      font-weight: ${Font.weight.extraBold};
      line-height: 1;
      margin: 0 0 40px;
    }
    .items-container {
      position: relative;
    }
    lvc-charlie-ecoute-icon {
      position: absolute;
      right: 0;
      margin-right: -235px;
      top: 50%;
      margin-top: -117.5px;
    }
    @media screen and (max-width: 991px) {
      .title {
        font-size: 48px;
        margin-bottom: 0px;
      }
      lvc-charlie-ecoute-icon {
        margin: 0;
        position: static;
      }
      lvc-charlie-ecoute-icon::part(image) {
          width: 158px;
          height: 158px;
      }
    }
    @media screen and (max-width: 540px) {
      .title {
        font-size: 24px;
      }
    }
  `

  eventListeners: EventListeners = [['.location-chip', 'click', this.onClick.bind(this)]]
}

export interface LvcDiscoeveryPlace {
  selected: string
}
